/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api/selectitem';
import { Panel } from 'primeng/panel';
import { Tab } from '../../../core/model/tab.model';
import { ConfigService } from '../../../core/services/config.service';
import { EditModeService } from '../../../core/services/edit-mode.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { QueryViewFormData } from '../../shared/model/query-view-form-data.model';


/**
 * @export
 * @class QueryViewFiltersComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-query-view-filters',
  templateUrl: './query-view-filters.component.html',
  styleUrls: ['./query-view-filters.component.scss']
})
export class QueryViewFiltersComponent implements OnInit, AfterViewInit, OnChanges {
  validationPopUp: boolean;
  validationMessage: string;
  configData;
  filtersForm: UntypedFormGroup;
  typeSearch = 'Locomotives';
  commonopsPicklist;
  locoGroup: any;
  trainGroup: any;
  geoGroup: any;
  activeIndex: number;
  filterCollpase: boolean;
  commodityGroup: any;
  @ViewChild(Panel) panelRef: Panel;
  @Input() tab: Tab;
  commodityError = false;
  minMaxError = false;
  minMaxGPSError = false;
  geoDescription = [];
  yardLocalSelected: Array<SelectItem> = [];
  locoFeaturesListSecondList: Array<SelectItem> = [];
  locoFeaturesListThirdList: Array<SelectItem> = [];
  selectAllCommodity = [];
  tabIndex: number;
  @Output() searhType = new EventEmitter();
  constructor(private configService: ConfigService, private _fb: UntypedFormBuilder,
    private lmsLoaderService: LmsLoaderService, private staticDataStoreService: StaticDataStoreService, private editModeService: EditModeService, private lmsModuleService: LmsModuleService) {
    this.configData = this.configService.getConfigData();
    this.tabIndex = this.configData.tabIndex.detailPage;
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
  }

  /**
   *  this is angular life cycle this method init when template load first time
   * @memberof QueryViewFiltersComponent
   */
  ngOnInit() {
    this.filtersForm = this._fb.group({
      filters: this._fb.array([])
    });
    this.defaultFilterValues();
    const control = <UntypedFormArray>this.filtersForm.controls['filters'];
    this.formControlLoco(control);
    this.formControlTrain(control);
    this.formControlGeo(control);
    this.formControlCommodity(control);
    this.locoGroup = control.controls[0];
    this.trainGroup = control.controls[1];
    this.geoGroup = control.controls[2];
    this.commodityGroup = control.controls[3];
    this.activeIndex = this.tab.queryView.activeIndex;
    this.filterCollpase = this.tab.queryView.filterCollpase || false;
    this.typeSearch = this.tab.queryView.typeSearch || 'Locomotives';
    setTimeout(() => {
      this.filtersForm.valueChanges.subscribe(data => {
        const trainForm = data.filters[1];
        this.minMaxGPSError = false;
        this.minMaxError = false;
        if (trainForm.trainCheck === 'notMovingPerGps') {
          if (parseInt(trainForm.minGpsHour, 10) > parseInt(trainForm.maxGpsHour, 10)) {
            this.minMaxGPSError = true;
          }

          if (parseInt(trainForm.minUnit, 10) > parseInt(trainForm.maxUnit, 10)) {
            this.minMaxError = true;
          }
        }

        if (!this.editModeService.isEditMode) {
          this.editModeService.setEditMode({ status: true, message: this.configData.messages.editModePopUp });
        }
      });
      // reset property set false
      // and set timeout due to all reset done in subforms
      if (this.tab.queryView.resetForm) {
        setTimeout(() => { this.tab.queryView.resetForm = false; }, 500);
      }
    }, 100);
  }
  /**
   * every time when input changes and before nginit it fire
   * @param {SimpleChanges} changes
   * @memberof QueryViewFiltersComponent
   */
  ngOnChanges(changes: SimpleChanges) {
    const tabChanged: boolean = changes['tab'] && (JSON.stringify(changes['tab'].currentValue) !== JSON.stringify(changes['tab'].previousValue));
    if (tabChanged && this.filtersForm) {
      if (this.tab && !this.tab.queryView) {
        this.tab.queryView = {};
        this.defaultFilterValues();
      }
      this.restoreForm();
      this.activeIndex = this.tab.queryView && this.tab.queryView.activeIndex ? this.tab.queryView.activeIndex : 0;
      this.filterCollpase = this.tab.queryView && this.tab.queryView.filterCollpase ? this.tab.queryView.filterCollpase : false;
      this.typeSearch = this.tab.queryView && this.tab.queryView.typeSearch ? this.tab.queryView.typeSearch : 'Locomotives';
    }
  }

  ngAfterViewInit() {
    this.setTabIndexToHeader();
  }

  /**
   * set default filter value
   * by this in all tab form default value set
   * @memberof QueryViewFiltersComponent
   */
  defaultFilterValues() {
    this.tab.queryView = <QueryViewFormData>{
      milesToEmptyCheck: this.tab.queryView.milesToEmptyCheck || false,
      hoursIdleCheck: this.tab.queryView.hoursIdleCheck || false,
      milesToEmpty: this.tab.queryView.milesToEmpty || 1,
      hoursIdle: this.tab.queryView.hoursIdle || 24,
      dueDayAirFlowValue: this.tab.queryView.dueDayAirFlowValue || '',
      withinDaysRadio: this.tab.queryView.withinDaysRadio || 'withinDays',
      withinDays: this.tab.queryView.withinDays || 2,
      allPastDue: this.tab.queryView.allPastDue || '',
      days: this.tab.queryView.days || -10,
      daysRadio: this.tab.queryView.daysRadio || '',
      permTag: this.tab.queryView.permTag || '',
      locoTag: this.tab.queryView.locoTag || '',
      classCode: this.tab.queryView.classCode || '',
      classCategory: this.tab.queryView.classCategory || '',
      incidentCode: this.tab.queryView.incidentCode || '',
      yardLocal: this.tab.queryView.yardLocal || '',
      yardLocalSelected: this.tab.queryView.yardLocalSelected || '',
      features1: this.tab.queryView.features1 || '',
      features1Exclude: this.tab.queryView.features1Exclude || '',
      features2: this.tab.queryView.features2 || '',
      features2Exclude: this.tab.queryView.features2Exclude || '',
      features3: this.tab.queryView.features3 || '',
      features3Exclude: this.tab.queryView.features3Exclude || '',
      offline: this.tab.queryView.offline || 'exclude',
      stored: this.tab.queryView.stored || 'exclude',
      questionMark: this.tab.queryView.questionMark || '',
      trainCheck: this.tab.queryView.trainCheck || '',
      dueOutHourValue: this.tab.queryView.dueOutHourValue || 4,
      noOfLocosValue: this.tab.queryView.noOfLocosValue || '>4',
      hotTrainValue: this.tab.queryView.hotTrainValue || '',
      minUnit: this.tab.queryView.minUnit || '0',
      maxUnit: this.tab.queryView.maxUnit || 15,
      minGpsHour: this.tab.queryView.minGpsHour || 8,
      maxGpsHour: this.tab.queryView.maxGpsHour || 24,
      excludeOriginatingTrains: this.tab.queryView.excludeOriginatingTrains || '',
      selectedGeoView: this.tab.queryView.selectedGeoView || 'system',
      selectedGeoDescriptions: this.tab.queryView.selectedGeoDescriptions || '',
      intermodalComm: this.tab.queryView.intermodalComm || '',
      coalComm: this.tab.queryView.coalComm || '',
      liteEngComm: this.tab.queryView.liteEngComm || '',
      foreignComm: this.tab.queryView.foreignComm || '',
      autoComm: this.tab.queryView.autoComm || '',
      emptyComm: this.tab.queryView.emptyComm || '',
      extraTrainComm: this.tab.queryView.extraTrainComm || '',
      passengerComm: this.tab.queryView.passengerComm || '',
      qMerchandise: this.tab.queryView.qMerchandise || '',
      grainComm: this.tab.queryView.grainComm || '',
      workTrainComm: this.tab.queryView.workTrainComm || '',
      otherComm: this.tab.queryView.otherComm || '',
      localComm: this.tab.queryView.localComm || '',
      bulkComm: this.tab.queryView.bulkComm || '',
      activeIndex: this.tab.queryView.activeIndex || 0,
      filterCollpase: this.tab.queryView.filterCollpase,
      typeSearch: this.tab.queryView.typeSearch || 'Locomotives'
    };
  }
  /**
   * locomotive form controls value set
   * @param {*} control
   * @memberof QueryViewFiltersComponent
   */
  formControlLoco(control: any) {
    control.push(
      this._fb.group({
        milesToEmptyCheck: this._fb.control(this.tab.queryView.milesToEmptyCheck),
        hoursIdleCheck: this._fb.control(this.tab.queryView.hoursIdleCheck),
        milesToEmpty: [this.tab.queryView.milesToEmpty, Validators.required],
        hoursIdle: this._fb.control(this.tab.queryView.hoursIdle, Validators.required),
        dueDayAirFlowValue: this._fb.control(this.tab.queryView.dueDayAirFlowValue),
        withinDays: this._fb.control(this.tab.queryView.withinDays),
        withinDaysRadio: this._fb.control(this.tab.queryView.withinDaysRadio),
        allPastDue: this._fb.control(this.tab.queryView.allPastDue),
        daysRadio: this._fb.control(this.tab.queryView.daysRadio),
        days: this._fb.control(this.tab.queryView.days),
        permTag: this._fb.control(this.tab.queryView.permTag),
        locoTag: this._fb.control(this.tab.queryView.locoTag),
        classCode: this._fb.control(this.tab.queryView.classCode),
        classCategory: this._fb.control(this.tab.queryView.classCategory),
        incidentCode: this._fb.control(this.tab.queryView.incidentCode),
        yardLocal: this._fb.control(this.tab.queryView.yardLocal),
        yardLocalSelected: this._fb.control(this.tab.queryView.yardLocalSelected),
        features1: this._fb.control(this.tab.queryView.features1),
        features1Exclude: this._fb.control(this.tab.queryView.features1Exclude),
        features2: this._fb.control(this.tab.queryView.features2),
        features2Exclude: this._fb.control(this.tab.queryView.features2Exclude),
        features3: this._fb.control(this.tab.queryView.features3),
        features3Exclude: this._fb.control(this.tab.queryView.features3Exclude),
        offline: this._fb.control(this.tab.queryView.offline),
        stored: this._fb.control(this.tab.queryView.stored),
        questionMark: this._fb.control(this.tab.queryView.questionMark)
      })
    );
  }

  /**
   * Train form controls value set
   * @param {*} controls
   * @memberof QueryViewFiltersComponent
   */
  formControlTrain(control: any) {
    control.push(
      this._fb.group({
        trainCheck: this._fb.control(this.tab.queryView.trainCheck),
        dueOutHourValue: this._fb.control(this.tab.queryView.dueOutHourValue),
        noOfLocosValue: this._fb.control(this.tab.queryView.noOfLocosValue),
        hotTrainValue: this._fb.control(this.tab.queryView.hotTrainValue),
        minUnit: this._fb.control(this.tab.queryView.minUnit),
        maxUnit: this._fb.control(this.tab.queryView.maxUnit),
        minGpsHour: this._fb.control(this.tab.queryView.minGpsHour),
        maxGpsHour: this._fb.control(this.tab.queryView.maxGpsHour),
        excludeOriginatingTrains: this._fb.control(this.tab.queryView.excludeOriginatingTrains)
      })
    );

  }

  /**
   * Geo form controls value set
   * @param {*} control
   * @memberof QueryViewFiltersComponent
   */
  formControlGeo(control: any) {
    control.push(
      this._fb.group({
        selectedGeoView: this._fb.control(this.tab.queryView.excludeOriginatingTrains),
        selectedGeoDescriptions: this._fb.control(this.tab.queryView.selectedGeoDescriptions)
      })
    );
  }

  /**
  formControlCommodity(control: any) {
   * locomotive form controls value set
   * @param {*} control
   * @memberof QueryViewFiltersComponent
   */
  formControlCommodity(control: any) {
    control.push(
      this._fb.group({
        intermodalComm: this._fb.control(this.tab.queryView.intermodalComm),
        coalComm: this._fb.control(this.tab.queryView.coalComm),
        liteEngComm: this._fb.control(this.tab.queryView.liteEngComm),
        foreignComm: this._fb.control(this.tab.queryView.foreignComm),
        autoComm: this._fb.control(this.tab.queryView.autoComm),
        emptyComm: this._fb.control(this.tab.queryView.emptyComm),
        extraTrainComm: this._fb.control(this.tab.queryView.extraTrainComm),
        passengerComm: this._fb.control(this.tab.queryView.passengerComm),
        qMerchandise: this._fb.control(this.tab.queryView.qMerchandise),
        grainComm: this._fb.control(this.tab.queryView.grainComm),
        workTrainComm: this._fb.control(this.tab.queryView.workTrainComm),
        otherComm: this._fb.control(this.tab.queryView.otherComm),
        localComm: this._fb.control(this.tab.queryView.localComm),
        bulkComm: this._fb.control(this.tab.queryView.bulkComm)
      })
    );
  }

  /**
   * on filter click toggle state of tab container
   * @param {any} event
   * @memberof QueryViewFiltersComponent
   */
  onFilterToggle(event) {
    if (!event.collapsed) {
      this.filterCollpase = event.collapsed;
    }
  }
  /**
   * when result come toggle tab container
   * @param {any} panelContainer
   * @memberof QueryViewFiltersComponent
   */
  toggleQueryView(panelContainer) {
    this.filterCollpase = !this.filterCollpase;
  }

  /**
   * on click of search trigger call or apply validation
   * @param {any} filtersForm
   * @returns
   * @memberof QueryViewFiltersComponent
   */
  searchFilterData(filtersForm) {
    if (!this.checkValuePresent()) {
      this.lmsLoaderService.showLoader();
      this.commodityError = false;
      this.minMaxError = false;
      this.minMaxGPSError = false;
      if (this.typeSearch === 'Trains') {
        if (this.checkAtLeastOneCommodityChecked() && !this.isTrainMinMaxLengthError() && !this.isTrainMinMaxGPSError()) {
          this.emitFormValueandCloseTab();
          this.updateQueryViewTabValues();
          this.lmsModuleService.updateSelectedTab(this.tab);
        } else {
          this.lmsLoaderService.hideLoader();
          if (this.isTrainMinMaxLengthError()) {
            this.showErrorOnTab(1, 'minmax');
          } else if (this.isTrainMinMaxGPSError()) {
            this.showErrorOnTab(1, 'minmaxgps');
          } else {
            this.showErrorOnTab(3, '');
          }
          return false;
        }
      } else {
        if (this.checkLocoErrorField()) {
          this.lmsLoaderService.hideLoader();
          this.showErrorOnTab(1, '');
          return false;
        } else {
          this.emitFormValueandCloseTab();
          this.updateQueryViewTabValues();
          this.lmsModuleService.updateSelectedTab(this.tab);
        }
      }
    }
  }

  /**
   * check any error occur on loco form
   * @private
   * @returns
   * @memberof QueryViewFiltersComponent
   */
  private checkLocoErrorField() {
    if ((this.locoGroup.controls.milesToEmptyCheck.value &&
      (this.locoGroup.controls.milesToEmpty.value === '' ||
        this.locoGroup.controls.milesToEmpty.value === '-' ||
        this.locoGroup.controls.milesToEmpty.value < 0 ||
        this.locoGroup.controls.milesToEmpty.value > 9999)) ||
      (this.locoGroup.controls.hoursIdleCheck.value && (this.locoGroup.controls.hoursIdle.value === '' ||
        this.locoGroup.controls.hoursIdle.value === '-' ||
        this.locoGroup.controls.hoursIdle.value < 0 ||
        this.locoGroup.controls.hoursIdleCheck.value > 999))
      ||
      (this.locoGroup.controls.dueDayAirFlowValue.value
        && (this.locoGroup.controls.withinDaysRadio.value
          && (this.locoGroup.controls.withinDays.value === ''
            || this.locoGroup.controls.withinDays.value === '-'
            || this.locoGroup.controls.withinDays.value < -999
            || this.locoGroup.controls.withinDays.value > 999))
        || (this.locoGroup.controls.daysRadio.value
          && (this.locoGroup.controls.days.value === ''
            || this.locoGroup.controls.withinDays.value === '-'
            || this.locoGroup.controls.days.value < -999
            || this.locoGroup.controls.days.value > 999))
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * check any error occur on train form
   * @private
   * @returns
   * @memberof QueryViewFiltersComponent
   */

  private checkTrainErrorField() {
    if ((this.trainGroup.controls.trainCheck.value === 'dueOutHour' && (this.trainGroup.controls.dueOutHourValue.value === '' ||
      this.trainGroup.controls.dueOutHourValue.value === '-' ||
      this.trainGroup.controls.dueOutHourValue.value < 0 ||
      this.trainGroup.controls.dueOutHourValue.value > 99))
      ||
      (this.trainGroup.controls.trainCheck.value === 'notMovingPerGps' && (this.trainGroup.controls.minUnit.value === ''
        || this.trainGroup.controls.maxUnit.value === ''
        || this.trainGroup.controls.maxGpsHour.value === ''
        || this.trainGroup.controls.minGpsHour.value === ''

        || this.trainGroup.controls.minUnit.value === '-'
        || this.trainGroup.controls.maxUnit.value === '-'
        || this.trainGroup.controls.maxGpsHour.value === '-'
        || this.trainGroup.controls.minGpsHour.value === '-'

        || parseInt(this.trainGroup.controls.minUnit.value, 10) < 0
        || parseInt(this.trainGroup.controls.maxUnit.value, 10) < 0
        || parseInt(this.trainGroup.controls.maxGpsHour.value, 10) < 0
        || parseInt(this.trainGroup.controls.minGpsHour.value, 10) < 0

        || parseInt(this.trainGroup.controls.minUnit.value, 10) > 99
        || parseInt(this.trainGroup.controls.maxUnit.value, 10) > 99
        || parseInt(this.trainGroup.controls.maxGpsHour.value, 10) > 99
        || parseInt(this.trainGroup.controls.minGpsHour.value, 10) > 99

      )
      )
      || this.isTrainMinMaxGPSError()
      || this.isTrainMinMaxLengthError()
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   *  check in train tab
   *  min max error come or not
   * @private
   * @returns
   * @memberof QueryViewFiltersComponent
   */
  private isTrainMinMaxLengthError() {
    if (this.trainGroup.controls.trainCheck.value === 'notMovingPerGps') {
      if (parseInt(this.trainGroup.controls.minUnit.value, 10) > parseInt(this.trainGroup.controls.maxUnit.value, 10)) {
        return true;
      }
    }
    return false;
  }

  /**
   * check in train tab
   * min max gps error
   * @private
   * @returns
   * @memberof QueryViewFiltersComponent
   */
  private isTrainMinMaxGPSError() {
    if (this.trainGroup.controls.trainCheck.value === 'notMovingPerGps') {
      if (parseInt(this.trainGroup.controls.minGpsHour.value, 10) > parseInt(this.trainGroup.controls.maxGpsHour.value, 10)) {
        return true;
      }
    }
    return false;
  }

  /**
   * swicth to tab on which respective form is not valid
   * @memberof QueryViewFiltersComponent
   */
  goToErrorTab(passIndex?: number) {
    if (passIndex) {
      this.showErrorOnTab(passIndex - 1, '');
    } else {
      let tabIndex = 0;
      if (!this.filtersForm.controls['filters']['controls'][0].valid) {
        tabIndex = 1;
      } else if (!this.filtersForm.controls['filters']['controls'][1].valid) {
        tabIndex = 2;
      } else if (!this.filtersForm.controls['filters']['controls'][2].valid) {
        tabIndex = 3;
      } else if (!this.filtersForm.controls['filters']['controls'][3].valid) {
        tabIndex = 4;
      }

      if (tabIndex) {
        this.showErrorOnTab(tabIndex - 1, '');
      }
    }
  }

  /**
   * close popup in which validation are applied
   * @memberof QueryViewFiltersComponent
   */
  closeValidationPopUp() {
    this.validationPopUp = false;
    this.validationMessage = '';
  }

  /**
   * This method disable search Button
   * @returns {boolean}
   * @memberof QueryViewFiltersComponent
   */
  checkValuePresent(): boolean {
    if ('Locomotives' === this.typeSearch) {
      if ((false === this.locoGroup.controls.milesToEmptyCheck.value
        && false === this.locoGroup.controls.hoursIdleCheck.value
        && !this.locoGroup.controls.dueDayAirFlowValue.value
        && !this.locoGroup.controls.permTag.value
        && !this.locoGroup.controls.locoTag.value
        && !this.locoGroup.controls.classCode.value
        && !this.locoGroup.controls.classCategory.value
        && !this.locoGroup.controls.incidentCode.value
        && !this.locoGroup.controls.yardLocal.value
        && !this.locoGroup.controls.features1.value
        && !this.locoGroup.controls.questionMark.value
        && !this.locoGroup.controls.stored.dirty
        && !this.locoGroup.controls.offline.dirty)
        || this.checkLocoErrorField()) {
        return true;
      } else {
        return false;
      }
    }
    if ('Trains' === this.typeSearch) {
      if (this.checkTrainErrorField()) {
        return true;
      }
      if (!this.trainGroup.controls.excludeOriginatingTrains.value && !this.trainGroup.controls.trainCheck.value) {
        return true;
      } else {
        if (this.trainGroup.controls.minUnit.errors && this.trainGroup.controls.minUnit.errors.minmax) {
          return true;
        }
        if (this.trainGroup.controls.minGpsHour.errors && this.trainGroup.controls.minGpsHour.errors.minmax) {
          return true;
        }
        if ('hotTrain' === this.trainGroup.controls.trainCheck.value && !this.trainGroup.controls.hotTrainValue.value) {
          return true;
        }
        return false;
      }
    }
  }

  /**
   * update query view value in respective tab
   * @memberof QueryViewFiltersComponent
   */
  updateQueryViewTabValues() {
    this.tab.queryView = {
      milesToEmptyCheck: this.filtersForm.controls['filters']['controls'][0].controls['milesToEmptyCheck'].value || false,
      milesToEmpty: this.filtersForm.controls['filters']['controls'][0].controls['milesToEmpty'].value || 1,
      hoursIdleCheck: this.filtersForm.controls['filters']['controls'][0].controls['hoursIdleCheck'].value || false,
      hoursIdle: this.filtersForm.controls['filters']['controls'][0].controls['hoursIdle'].value || 4,
      dueDayAirFlowValue: this.filtersForm.controls['filters']['controls'][0].controls['dueDayAirFlowValue'].value || '',
      withinDaysRadio: this.filtersForm.controls['filters']['controls'][0].controls['withinDaysRadio'].value || 'withinDays',
      withinDays: this.filtersForm.controls['filters']['controls'][0].controls['withinDays'].value || 2,
      allPastDue: this.filtersForm.controls['filters']['controls'][0].controls['allPastDue'].value || '',
      days: this.filtersForm.controls['filters']['controls'][0].controls['days'].value || -10,
      daysRadio: this.filtersForm.controls['filters']['controls'][0].controls['daysRadio'].value || '',
      permTag: this.filtersForm.controls['filters']['controls'][0].controls['permTag'].value || '',
      locoTag: this.filtersForm.controls['filters']['controls'][0].controls['locoTag'].value || '',
      classCode: this.filtersForm.controls['filters']['controls'][0].controls['classCode'].value || '',
      classCategory: this.filtersForm.controls['filters']['controls'][0].controls['classCategory'].value || '',
      incidentCode: this.filtersForm.controls['filters']['controls'][0].controls['incidentCode'].value || '',
      yardLocal: this.filtersForm.controls['filters']['controls'][0].controls['yardLocal'].value || '',
      yardLocalSelected: this.filtersForm.controls['filters']['controls'][0].controls['yardLocalSelected'].value || '',
      features1: this.filtersForm.controls['filters']['controls'][0].controls['features1'].value || '',
      features1Exclude: this.filtersForm.controls['filters']['controls'][0].controls['features1Exclude'].value || '',
      features2: this.filtersForm.controls['filters']['controls'][0].controls['features2'].value || '',
      features2Exclude: this.filtersForm.controls['filters']['controls'][0].controls['features2Exclude'].value || '',
      features3: this.filtersForm.controls['filters']['controls'][0].controls['features3'].value || '',
      features3Exclude: this.filtersForm.controls['filters']['controls'][0].controls['features3Exclude'].value || '',
      offline: this.filtersForm.controls['filters']['controls'][0].controls['offline'].value || 'exclude',
      stored: this.filtersForm.controls['filters']['controls'][0].controls['stored'].value || 'exclude',
      questionMark: this.filtersForm.controls['filters']['controls'][0].controls['questionMark'].value || '',
      trainCheck: this.filtersForm.controls['filters']['controls'][1].controls['trainCheck'].value || '',
      dueOutHourValue: this.filtersForm.controls['filters']['controls'][1].controls['dueOutHourValue'].value || 4,
      noOfLocosValue: this.filtersForm.controls['filters']['controls'][1].controls['noOfLocosValue'].value || '>4',
      hotTrainValue: this.filtersForm.controls['filters']['controls'][1].controls['hotTrainValue'].value || '',
      minUnit: this.filtersForm.controls['filters']['controls'][1].controls['minUnit'].value || '0',
      maxUnit: this.filtersForm.controls['filters']['controls'][1].controls['maxUnit'].value || 15,
      minGpsHour: this.filtersForm.controls['filters']['controls'][1].controls['minGpsHour'].value || 8,
      maxGpsHour: this.filtersForm.controls['filters']['controls'][1].controls['maxGpsHour'].value || 24,
      excludeOriginatingTrains: this.filtersForm.controls['filters']['controls'][1].controls['excludeOriginatingTrains'].value || '',
      selectedGeoView: this.filtersForm.controls['filters']['controls'][2].controls['selectedGeoView'].value || 'system',
      selectedGeoDescriptions: this.filtersForm.controls['filters']['controls'][2].controls['selectedGeoDescriptions'].value || '',
      intermodalComm: this.filtersForm.controls['filters']['controls'][3].controls['intermodalComm'].value || '',
      coalComm: this.filtersForm.controls['filters']['controls'][3].controls['coalComm'].value || '',
      liteEngComm: this.filtersForm.controls['filters']['controls'][3].controls['liteEngComm'].value || '',
      foreignComm: this.filtersForm.controls['filters']['controls'][3].controls['foreignComm'].value || '',
      autoComm: this.filtersForm.controls['filters']['controls'][3].controls['autoComm'].value || '',
      emptyComm: this.filtersForm.controls['filters']['controls'][3].controls['emptyComm'].value || '',
      extraTrainComm: this.filtersForm.controls['filters']['controls'][3].controls['extraTrainComm'].value || '',
      passengerComm: this.filtersForm.controls['filters']['controls'][3].controls['passengerComm'].value || '',
      qMerchandise: this.filtersForm.controls['filters']['controls'][3].controls['qMerchandise'].value || '',
      grainComm: this.filtersForm.controls['filters']['controls'][3].controls['grainComm'].value || '',
      workTrainComm: this.filtersForm.controls['filters']['controls'][3].controls['workTrainComm'].value || '',
      otherComm: this.filtersForm.controls['filters']['controls'][3].controls['otherComm'].value || '',
      localComm: this.filtersForm.controls['filters']['controls'][3].controls['localComm'].value || '',
      bulkComm: this.filtersForm.controls['filters']['controls'][3].controls['bulkComm'].value || '',
      activeIndex: this.activeIndex,
      filterCollpase: this.filterCollpase,
      typeSearch: this.typeSearch
    };
  }

  /**
   * reset commodity error
   * @param {any} event
   * @memberof QueryViewFiltersComponent
   */
  resetCommodityError(event) {
    this.commodityError = event.value;
  }

  /**
   * emit form value which will call load method
   * @memberof QueryViewFiltersComponent
   */
  emitFormValueandCloseTab() {
    setTimeout(() => {
      this.searhType.emit({ requestObject: this.filtersForm.value, typeName: this.typeSearch });
    }, 200);
    this.filterCollpase = true;
  }

  /**
   * show error tab
   * @param {number} index
   * @param {string} message
   * @memberof QueryViewFiltersComponent
   */
  showErrorOnTab(index: number, message: string) {
    this.activeIndex = index;
    this.minMaxError = (index === 1 && message === 'minmax' ? true : false);
    this.minMaxGPSError = (index === 1 && message === 'minmaxgps' ? true : false);
    this.commodityError = (index === 3 ? true : false);
  }

  /**
   * in this we are checking one commodity is atleast selected
   * @returns
   * @memberof QueryViewFiltersComponent
   */
  checkAtLeastOneCommodityChecked() {
    if (this.filtersForm && this.filtersForm.value && this.filtersForm.value.filters && this.filtersForm.value.filters.length > 1) {
      if (this.filtersForm.value.filters[1] && this.filtersForm.value.filters[1].trainCheck && this.filtersForm.value.filters[1].trainCheck === 'hotTrain') {
        return true;
      }
    }
    const commodityArray = ['intermodalComm', 'coalComm', 'liteEngComm', 'foreignComm', 'autoComm', 'emptyComm', 'extraTrainComm', 'passengerComm', 'qMerchandise', 'grainComm', 'workTrainComm', 'otherComm', 'localComm', 'bulkComm'];
    for (let index = 0; index < commodityArray.length; index++) {
      const element = commodityArray[index];
      if (this.filtersForm.value.filters[3][element]) {
        return true;
      }
    }
    return false;
  }

  /**
   * when tab change reset error related to min max
   * @param {any} event
   * @memberof QueryViewFiltersComponent
   */
  tabChange(event) {
    this.activeIndex = event.index;
    if (event.index === 1) {
      this.typeSearch = 'Trains';
      this.minMaxError = false;
      this.minMaxGPSError = false;
    }
    if (event.index === 0) {
      this.typeSearch = 'Locomotives';
      this.commodityError = false;
    }

  }

  /**
   * reset form and reset all valiuidation error
   * @memberof QueryViewFiltersComponent
   */
  resetForm() {
    this.resetFilterLoco();
    this.resetFilterTrain();
    this.resetFilterGeo();
    this.resetFilterCommodity();
    this.resetAllOtherFilter();
    this.minMaxError = false;
    this.minMaxGPSError = false;
    this.commodityError = false;
    this.tab.queryView.resetForm = true;
    this.editModeService.setEditMode({ status: false, message: '' });
  }

  /**
   * reset train filters
   * @memberof QueryViewFiltersComponent
   */
  resetFilterTrain() {
    this.filtersForm.controls['filters']['controls'][1].reset({
      trainCheck: '',
      dueOutHourValue: 4,
      noOfLocosValue: '>4',
      hotTrainValue: '',
      minUnit: '0',
      maxUnit: 15,
      minGpsHour: 8,
      maxGpsHour: 24,
      excludeOriginatingTrains: '',
    });
  }

  /**
   * Reset other filters left apart from Form Control
   * @memberof QueryViewFiltersComponent
   */
  resetAllOtherFilter() {
    this.geoDescription = [];
    this.yardLocalSelected = [];
    this.locoFeaturesListSecondList = [];
    this.locoFeaturesListThirdList = [];
    this.selectAllCommodity = ['selectAll'];
  }

  /**
   * reset geo filter
   * @memberof QueryViewFiltersComponent
   */
  resetFilterGeo() {
    this.filtersForm.controls['filters']['controls'][2].reset({
      selectedGeoView: 'system',
      selectedGeoDescriptions: ''
    });
  }

  /**
   * reset commodity filter
   * @memberof QueryViewFiltersComponent
   */
  resetFilterCommodity() {
    this.filtersForm.controls['filters']['controls'][3].reset({
      intermodalComm: '',
      coalComm: '',
      liteEngComm: '',
      foreignComm: '',
      autoComm: '',
      emptyComm: '',
      extraTrainComm: '',
      passengerComm: '',
      qMerchandise: '',
      grainComm: '',
      workTrainComm: '',
      otherComm: '',
      localComm: '',
      bulkComm: ''
    });
  }

  /**
   * reset loco filter
   * @memberof QueryViewFiltersComponent
   */
  resetFilterLoco() {
    this.filtersForm.controls['filters']['controls'][0].reset({
      milesToEmptyCheck: false,
      hoursIdleCheck: false,
      milesToEmpty: 1,
      hoursIdle: 24,
      dueDayAirFlowValue: '',
      withinDaysRadio: 'withinDays',
      withinDays: 2,
      allPastDue: '',
      days: -10,
      daysRadio: '',
      permTag: '',
      locoTag: '',
      classCode: '',
      classCategory: '',
      incidentCode: '',
      yardLocal: '',
      yardLocalSelected: '',
      features1: '',
      features1Exclude: '',
      features2: '',
      features2Exclude: '',
      features3: '',
      features3Exclude: '',
      offline: 'exclude',
      stored: 'exclude',
      questionMark: ''
    });
  }

  private setTabIndexToHeader() {
    const tabView = document.getElementsByClassName('p-tabview');
    if (tabView && tabView.length > 0) {
      const headers = tabView[0].querySelectorAll('.p-tabview-nav li a');
      if (headers && headers.length >= 4) {
        for (let i = 0; i < 4; i++) {
          headers[i].setAttribute('tabindex', '' + (this.tabIndex + (i * 400)));
        }
      }
    }
  }

  /**
   * reset form
   * @memberof QueryViewFiltersComponent
   */
  restoreForm() {
    this.restoreFilterLoco();
    this.restoreFilterTrain();
    this.restoreFilterGeo();
    this.restoreFilterCommodity();
    this.restoreAllOtherFilter();
  }

  /**
   * reset all other filter
   * @memberof QueryViewFiltersComponent
   */
  restoreAllOtherFilter() {
    this.geoDescription = [];
    this.yardLocalSelected = [];
    this.locoFeaturesListSecondList = [];
    this.locoFeaturesListThirdList = [];
  }

  /**restore loco filter
   * @memberof QueryViewFiltersComponent
   */
  restoreFilterLoco() {
    this.filtersForm.controls['filters']['controls'][0].reset({
      milesToEmptyCheck: this.tab.queryView && this.tab.queryView.milesToEmptyCheck ? this.tab.queryView.milesToEmptyCheck : false,
      hoursIdleCheck: this.tab.queryView && this.tab.queryView.hoursIdleCheck ? this.tab.queryView.hoursIdleCheck : false,
      milesToEmpty: this.tab.queryView && this.tab.queryView.milesToEmpty ? this.tab.queryView.milesToEmpty : 1,
      hoursIdle: this.tab.queryView && this.tab.queryView.hoursIdle ? this.tab.queryView.hoursIdle : 24,
      dueDayAirFlowValue: this.tab.queryView && this.tab.queryView.dueDayAirFlowValue ? this.tab.queryView.dueDayAirFlowValue : '',
      withinDaysRadio: this.tab.queryView && this.tab.queryView.withinDaysRadio ? this.tab.queryView.withinDaysRadio : 'withinDays',
      withinDays: this.tab.queryView && this.tab.queryView.withinDays ? this.tab.queryView.withinDays : 2,
      allPastDue: this.tab.queryView && this.tab.queryView.allPastDue ? this.tab.queryView.allPastDue : '',
      days: this.tab.queryView && this.tab.queryView.days ? this.tab.queryView.days : -10,
      daysRadio: this.tab.queryView && this.tab.queryView.daysRadio ? this.tab.queryView.daysRadio : '',
      permTag: this.tab.queryView && this.tab.queryView.permTag ? this.tab.queryView.permTag : '',
      locoTag: this.tab.queryView && this.tab.queryView.locoTag ? this.tab.queryView.locoTag : '',
      classCode: this.tab.queryView && this.tab.queryView.classCode ? this.tab.queryView.classCode : '',
      classCategory: this.tab.queryView && this.tab.queryView.classCategory ? this.tab.queryView.classCategory : '',
      incidentCode: this.tab.queryView && this.tab.queryView.incidentCode ? this.tab.queryView.incidentCode : '',
      yardLocal: this.tab.queryView && this.tab.queryView.yardLocal ? this.tab.queryView.yardLocal : '',
      yardLocalSelected: this.tab.queryView && this.tab.queryView.yardLocalSelected ? this.tab.queryView.yardLocalSelected : '',
      features1: this.tab.queryView && this.tab.queryView.features1 ? this.tab.queryView.features1 : '',
      features1Exclude: this.tab.queryView && this.tab.queryView.features1Exclude ? this.tab.queryView.features1Exclude : '',
      features2: this.tab.queryView && this.tab.queryView.features2 ? this.tab.queryView.features2 : '',
      features2Exclude: this.tab.queryView && this.tab.queryView.features2Exclude ? this.tab.queryView.features2Exclude : '',
      features3: this.tab.queryView && this.tab.queryView.features3 ? this.tab.queryView.features3 : '',
      features3Exclude: this.tab.queryView && this.tab.queryView.features3Exclude ? this.tab.queryView.features3Exclude : '',
      offline: this.tab.queryView && this.tab.queryView.offline ? this.tab.queryView.offline : 'exclude',
      stored: this.tab.queryView && this.tab.queryView.stored ? this.tab.queryView.stored : 'exclude',
      questionMark: this.tab.queryView && this.tab.queryView.questionMark ? this.tab.queryView.questionMark : ''
    });
  }

  /**
   * restore train filter
   * @memberof QueryViewFiltersComponent
   */
  restoreFilterTrain() {
    this.filtersForm.controls['filters']['controls'][1].reset({
      trainCheck: this.tab.queryView && this.tab.queryView.trainCheck ? this.tab.queryView.trainCheck : '',
      dueOutHourValue: this.tab.queryView && this.tab.queryView.dueOutHourValue ? this.tab.queryView.dueOutHourValue : 4,
      noOfLocosValue: this.tab.queryView && this.tab.queryView.noOfLocosValue ? this.tab.queryView.noOfLocosValue : '>4',
      hotTrainValue: this.tab.queryView && this.tab.queryView.hotTrainValue ? this.tab.queryView.hotTrainValue : '',
      minUnit: this.tab.queryView && this.tab.queryView.minUnit ? this.tab.queryView.minUnit : '0',
      maxUnit: this.tab.queryView && this.tab.queryView.maxUnit ? this.tab.queryView.maxUnit : 15,
      minGpsHour: this.tab.queryView && this.tab.queryView.minGpsHour ? this.tab.queryView.minGpsHour : 8,
      maxGpsHour: this.tab.queryView && this.tab.queryView.maxGpsHour ? this.tab.queryView.maxGpsHour : 24,
      excludeOriginatingTrains: this.tab.queryView && this.tab.queryView.excludeOriginatingTrains ? this.tab.queryView.excludeOriginatingTrains : '',
    });
  }

  /**
   * restore Geo filter
   * @memberof QueryViewFiltersComponent
   */
  restoreFilterGeo() {
    this.filtersForm.controls['filters']['controls'][2].reset({
      selectedGeoView: this.tab.queryView && this.tab.queryView.selectedGeoView ? this.tab.queryView.selectedGeoView : 'system',
      selectedGeoDescriptions: this.tab.queryView && this.tab.queryView.selectedGeoDescriptions ? this.tab.queryView.selectedGeoDescriptions : ''
    });
  }

  /**
   * restore Commodity filter
   * @memberof QueryViewFiltersComponent
   */
  restoreFilterCommodity() {
    this.filtersForm.controls['filters']['controls'][3].reset({
      intermodalComm: this.tab.queryView && this.tab.queryView.intermodalComm ? this.tab.queryView.intermodalComm : '',
      coalComm: this.tab.queryView && this.tab.queryView.coalComm ? this.tab.queryView.coalComm : '',
      liteEngComm: this.tab.queryView && this.tab.queryView.liteEngComm ? this.tab.queryView.liteEngComm : '',
      foreignComm: this.tab.queryView && this.tab.queryView.foreignComm ? this.tab.queryView.foreignComm : '',
      autoComm: this.tab.queryView && this.tab.queryView.autoComm ? this.tab.queryView.autoComm : '',
      emptyComm: this.tab.queryView && this.tab.queryView.emptyComm ? this.tab.queryView.emptyComm : '',
      extraTrainComm: this.tab.queryView && this.tab.queryView.extraTrainComm ? this.tab.queryView.extraTrainComm : '',
      passengerComm: this.tab.queryView && this.tab.queryView.passengerComm ? this.tab.queryView.passengerComm : '',
      qMerchandise: this.tab.queryView && this.tab.queryView.qMerchandise ? this.tab.queryView.qMerchandise : '',
      grainComm: this.tab.queryView && this.tab.queryView.grainComm ? this.tab.queryView.grainComm : '',
      workTrainComm: this.tab.queryView && this.tab.queryView.workTrainComm ? this.tab.queryView.workTrainComm : '',
      otherComm: this.tab.queryView && this.tab.queryView.otherComm ? this.tab.queryView.otherComm : '',
      localComm: this.tab.queryView && this.tab.queryView.localComm ? this.tab.queryView.localComm : '',
      bulkComm: this.tab.queryView && this.tab.queryView.bulkComm ? this.tab.queryView.bulkComm : ''
    });
  }
}

